const ROMAN_ITEM = /(?<!\S)(I{1,3}|IV|VI{0,3}|IX|X)([.)-])\s+/g;
const TRUE_FALSE_MARKER = /(?<!\S)\(\s*\)/g;

export function formatQuestionStatement(text) {
  if (!text || text.includes('\n')) {
    return text;
  }

  const formatted = text
    .replace(ROMAN_ITEM, '\n$1$2 ')
    .replace(TRUE_FALSE_MARKER, '\n( )');

  const firstBreak = formatted.indexOf('\n');
  if (firstBreak === 0) {
    // Item is the very first thing in the text: no intro line to separate from.
    return formatted.slice(1);
  }
  if (firstBreak > 0) {
    // Blank line before the first item, to separate it from the intro text.
    return formatted.slice(0, firstBreak) + '\n' + formatted.slice(firstBreak);
  }
  return formatted;
}
